import { baseAuthUrl } from "../api";

const clientId =
  "i69CUIFc9WrC7okY3SdaOYQUCBmqYl5iTKmMXCZdj6cdpbNdpWVaORC7uxV45eiU";

export const goToLogin = () => {
  window.location.href = `${baseAuthUrl}/oauth2/authorize?response_type=code&scope=identity%20identity%5Bemail%5D%20identity.memberships&client_id=${clientId}&redirect_uri=${window.location.origin}/login`;
};

export const logout = () => {
  window.localStorage.clear();
  window.location.href = "/";
};

export const getFlagSource = (team) => {
  return `/flags/${team}.png`;
};

export const teamNames = {
  DYN: "ДИН",
  SHA: "ШАХ",
  OLE: "ОЛЕ",
  RUH: "РУХ",
  POL: "ПОЛ",
  MET: "ХАР",
  ZOR: "ЗОР",
  VOR: "ВОР",
  LIB: "ЛІБ",
  MYN: "МИН",
  LNZ: "ЛНЗ",
  KRY: "КРИ",
  VER: "ВЕР",
  OBO: "ОБО",
  CHO: "ЧОР",
  KOL: "КОЛ",
  ING: "ІНГ",
  KAR: "КАР",
  EPI: "ЕПІ",
  PLT: "ПЛТ",
  KUD: "КУД",
  BUK: "БУК",
};

export const getTeamName = (teamId, teams, isMobile = false) => {
  if (!teamId) return;
  const targetTeam = teams.find((team) => team.TeamId === teamId);
  return isMobile ? teamNames[targetTeam?.TeamId] : targetTeam?.Name;
};

export const getPlayerNoString = (playerNo) => {
  if (!playerNo) return "";
  const digitsNumber = playerNo.toString().length;
  if (digitsNumber === 1) {
    return "00" + playerNo;
  } else if (digitsNumber === 2) {
    return "0" + playerNo;
  }

  return playerNo.toString();
};

export const getShownRound = (roundNumber) => {
  const ROUND_OFFSET = 0;
  return roundNumber - ROUND_OFFSET;
};
